"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ListSubheader_1 = __importDefault(require("@material-ui/core/ListSubheader"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var react_window_1 = require("react-window");
var LISTBOX_PADDING = 8; // px
function renderRow(props) {
    var data = props.data, index = props.index, style = props.style;
    return (0, react_1.cloneElement)(data[index], {
        style: __assign(__assign({}, style), { top: style.top + LISTBOX_PADDING }),
    });
}
var OuterElementContext = (0, react_1.createContext)({});
var OuterElementType = (0, react_1.forwardRef)(function OuterElementType(props, ref) {
    var outerProps = (0, react_1.useContext)(OuterElementContext);
    return react_1.default.createElement("div", __assign({ ref: ref }, props, outerProps));
});
// Adapter for react-window
var useVirtualizedListbox = function (rowHeight) {
    if (rowHeight === void 0) { rowHeight = 36; }
    return (0, react_1.forwardRef)(function ListboxComponent(props, ref) {
        // eslint-disable-next-line react/prop-types
        var children = props.children, other = __rest(props, ["children"]);
        var itemData = react_1.Children.toArray(children);
        var itemCount = itemData.length;
        var itemSize = rowHeight;
        var getChildSize = function (child) {
            if ((0, react_1.isValidElement)(child) && child.type === ListSubheader_1.default) {
                return 48;
            }
            return itemSize;
        };
        var getHeight = function () {
            if (itemCount > 8) {
                return 8 * itemSize;
            }
            return itemData.map(getChildSize).reduce(function (a, b) { return a + b; }, 0);
        };
        return (react_1.default.createElement("div", { ref: ref },
            react_1.default.createElement(OuterElementContext.Provider, { value: other },
                react_1.default.createElement(react_window_1.VariableSizeList, { itemData: itemData, height: getHeight(), width: "100%", key: itemCount, outerElementType: OuterElementType, innerElementType: "ul", itemSize: function (index) { return getChildSize(itemData[index]); }, overscanCount: 5, itemCount: itemCount }, renderRow))));
    });
};
useVirtualizedListbox.propTypes = {
    rowHeight: prop_types_1.default.number,
};
exports.default = useVirtualizedListbox;
//# sourceMappingURL=useVirtualizedListbox.js.map